import { Component, OnInit } from "@angular/core";
import { UntypedFormBuilder, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Observable } from "rxjs";
import { GrupoDTO, InvestigacionDTO } from "@DTOS";
import { Nilable } from "@shared/utils";
import { Store } from "@ngxs/store";
import { InvestigacionesAcciones, State } from "@shared/states";
import { filter, take } from "rxjs/operators";

interface Datos {
    research?: Nilable<InvestigacionDTO>;
    group?: Nilable<GrupoDTO>;
}

@Component({
    selector: "app-modal-prueba-interna",
    templateUrl: "./modal-prueba-interna.component.html",
    styleUrls: ["./modal-prueba-interna.component.scss"]
})
export class ModalPruebaInternaComponent implements OnInit {
    public nombre: string;

    public formGroup = this.fb.group({
        investigacion: [null, Validators.required],
        grupo: [null, Validators.required]
    });

    public grupos: Nilable<Observable<GrupoDTO[]>> = null;
    private investigacion: InvestigacionDTO;

    constructor(private activeModal: NgbActiveModal, private fb: UntypedFormBuilder, private store: Store) { }

    ngOnInit() {
        this.store.dispatch(new InvestigacionesAcciones.ObtenerId(331));
        this.store.select((state: State) => state.investigaciones.investigacionSeleccionada).pipe(
            filter((investigacion): investigacion is InvestigacionDTO => investigacion != null),
            take(1)
        ).subscribe(investigacion => this.procesarInvestigacion(investigacion));
    }

    public cancelar() {
        this.activeModal.dismiss();
    }

    public guardar() {
        const datos: Datos = { research: null, group: null };

        datos.research = this.formGroup.value.investigacion;
        datos.group = this.formGroup.value.grupo;

        this.activeModal.close(datos);
    }

    private procesarInvestigacion(investigacion: InvestigacionDTO) {
        this.investigacion = investigacion;
        this.nombre = investigacion.nombre;
        this.store.dispatch(new InvestigacionesAcciones.ObtenerGrupos(investigacion));
        this.store.select((state: State) => state.investigaciones.gruposInvestigacionSeleccionada).pipe(
            filter((grupos): grupos is GrupoDTO[] => grupos != null),
            take(1)
        ).subscribe(grupos => this.procesarGrupos(grupos));
    }

    private procesarGrupos(grupos: GrupoDTO[]) {
        this.formGroup.setValue({
            investigacion: this.investigacion,
            grupo: grupos.find(grupoDTO => grupoDTO.id === 12)
        });
    }
}
